<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import NotificationBell from './NotificationBell.vue';
import wootConstants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';
import { useTrack } from 'dashboard/composables';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    NotificationBell,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isMobileBottomBar: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggleAccounts', 'openNotificationPanel', 'openKeyShortcutModal'],
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
    };
  },
  methods: {
    frontendURL,
    toggleAccountModal() {
      this.$emit('toggleAccounts');
    },
    openNotificationPanel() {
      useTrack(ACCOUNT_EVENTS.OPENED_NOTIFICATIONS);
      this.$emit('openNotificationPanel');
    },
  },
};
</script>

<template>
  <div
    :class="{
      // Desktop
      'flex flex-col justify-between h-full border-r bg-n-background dark:bg-n-background rtl:border-l rtl:border-r-0 py-6 px-2 border-n-weak': !isMobileBottomBar,
      // Mobile bottom bar: h-16 (70px), tablet (84px)
      'flex flex-row items-center justify-center w-full h-[4.375rem] sm:h-[5.25rem] bg-n-solid-1 dark:bg-n-solid-1 border-t px-4 sm:px-6 gap-4 sm:gap-6 border-n-weak': isMobileBottomBar,
    }"
  >
    <!-- Desktop Layout -->
    <template v-if="!isMobileBottomBar">
      <div class="flex flex-col items-center gap-6">
        <Logo
          :source="logoSource"
          :name="installationName"
          :account-id="accountId"
        />
        <PrimaryNavItem
          v-for="menuItem in menuItems"
          :id="menuItem.key"
          :key="menuItem.toState"
          :icon="menuItem.icon"
          :name="menuItem.label"
          :to="menuItem.toState"
          :is-child-menu-active="menuItem.key === activeMenuItem"
          :tooltip-direction="isMobileView ? 'top' : 'right'"
        />
      </div>
      <div class="flex flex-col items-center justify-end pb-6">
        <a
          v-if="!isACustomBrandedInstance"
          v-tooltip.right="$t(`SIDEBAR.DOCS`)"
          :href="helpDocsURL"
          class="relative flex items-center justify-center w-10 h-10 my-2 rounded-lg text-n-slate-11 dark:text-n-slate-11 hover:bg-n-solid-3 dark:hover:bg-n-solid-3 hover:text-n-slate-12"
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          <fluent-icon icon="book-open-globe" />
          <span class="sr-only">{{ $t(`SIDEBAR.DOCS`) }}</span>
        </a>
        <NotificationBell @open-notification-panel="openNotificationPanel" />
      </div>
    </template>

    <!-- Mobile Bottom Bar Layout - Only Navigation Items -->
    <template v-else>
      <div class="flex flex-row items-center justify-between gap-4 w-full">
        <PrimaryNavItem
          v-for="menuItem in menuItems"
          :id="menuItem.key"
          :key="menuItem.toState"
          :icon="menuItem.icon"
          :name="menuItem.label"
          :to="menuItem.toState"
          :is-child-menu-active="menuItem.key === activeMenuItem"
          :tooltip-direction="'top'"
        />
      </div>
    </template>
  </div>
</template>
